import React from 'react'
import Create from '../../../components/pages/branches/create'
import List from "./index"
import Accounting from './Accounting'

import CreateBranch from './Branch/Create'
import CreateRefactored from './CreateRefactored'

export const paths = [
    {
        path: "/branches/create",
        component: Create,
    },
    {
        path: "/branches/create-refactored",
        component: CreateRefactored,
    },
    {
        path: "/branches/create2",
        component: CreateBranch,
    },
    {
        path: "/branches",
        component: List
    },
    {
        path: "/accounting",
        component: Accounting
    },
]

export const BranchesRouters = {
    icon: "building",
    path: "/branches",
    label: 'Filiais',
    tree: [
        {
            icon: "plus",
            path: "/branches/create",
            label: "Cadastrar",
        },
        {
            icon: "building",
            path: "/branches",
            label: "Ver Filiais"
        },
        {
            icon: "building",
            path: "/accounting",
            label: "Contabilidade"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/routers.js